import './CertificateTemplate.css';

const FALLBACK_LOGO = `${process.env.PUBLIC_URL}/prasha-logo.jpeg`;

function looksLikeEmail(value) {
  return Boolean(value && /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value.trim()));
}

function resolveCertificateName(certificate) {
  const name = certificate?.user_name?.trim() || '';
  const resolvedName = certificate?.resolved_user_name?.trim() || '';
  const candidate = resolvedName || name;
  console.log('candidate', candidate);

  if (candidate && !looksLikeEmail(candidate)) {
    return candidate;
  }

  if (candidate) {
    return candidate.split('@', 1)[0];
  }

  return 'Learner';
}

function formatCertificateDate(value) {
  if (!value) return '';

  return new Date(value).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
}

export default function CertificateTemplate({ certificate }) {
  console.log('certificate', certificate);
  const logoSrc = certificate?.university_logo_url || FALLBACK_LOGO;
  const providerName = certificate?.provider_name || 'PRASHA';
  const duration = certificate?.course_duration || 'Self-paced program';
  const universityIdentifier = certificate?.university_identifier || 'Not provided';
  const certificateName = resolveCertificateName(certificate);

  return (
    <div className="certificate-shell">
      <div className="certificate-template">
        <img
          src={logoSrc}
          alt={`${providerName} logo`}
          className="certificate-logo"
          onError={(event) => {
            event.currentTarget.onerror = null;
            event.currentTarget.src = FALLBACK_LOGO;
          }}
        />

        <div className="certificate-ribbon">
          <svg
            className="certificate-ribbon-art"
            viewBox="0 0 140 700"
            preserveAspectRatio="none"
            aria-hidden="true"
          >
            <defs>
              <linearGradient id="certificateRibbonGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#0f4c4c" />
                <stop offset="100%" stopColor="#1f7a7a" />
              </linearGradient>
            </defs>
            <rect width="140" height="700" fill="url(#certificateRibbonGradient)" />
          </svg>
          <div className="certificate-ribbon-text">COURSE CERTIFICATE</div>
        </div>

        <div className="certificate-watermark" aria-hidden="true">
          <div className="certificate-watermark-mark">P</div>
        </div>

        <div className="certificate-content">
          <p className="certificate-kicker">CERTIFICATE OF COMPLETION</p>
          <p className="certificate-copy">This is to certify that</p>
          <h2 className="certificate-name">{certificateName}</h2>
          <p className="certificate-copy">has successfully completed</p>
          <h3 className="certificate-course">{certificate?.course_title}</h3>
          <p className="certificate-details">
            Duration: <span>{duration}</span> | Provider: <span>{providerName}</span>
          </p>

          <div className="certificate-meta">
            <div className="certificate-pill">Certificate ID: {certificate?.certificate_id}</div>
            <div className="certificate-pill">University ID: {universityIdentifier}</div>
          </div>
        </div>

        <div className="certificate-signature">
          <div className="certificate-signature-mark">PRASHA</div>
          <p className="certificate-signature-label">Authorized Signatory</p>
          <p className="certificate-signature-id">Issued by {providerName}</p>
        </div>

        <div className="certificate-date">
          <p className="certificate-date-label">Issued On</p>
          <p className="certificate-date-value">{formatCertificateDate(certificate?.issue_date)}</p>
        </div>
      </div>
    </div>
  );
}
